<mat-dialog-content>
    <h2 class="message">{{message | translate}}</h2>

</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close class="button_close">{{"siren-admin-translation.generic.dialog.navigate_login" | translate}}</button>
</mat-dialog-actions>
